import { onPath } from '../utils/path';
import { getWindow, whenOlarkExists, selectOne } from '../utils/dom-utils';
import getParameterByName from '../utils/url';
import { olarkSetRid } from '../rid';

onPath('/integrations/*', () => {
  whenOlarkExists(olark => {

    const win = getWindow();
    const integrationName = getWindow().landingPageRid;
    const button = selectOne('#expand-chatbox-button');
    button.addEventListener('click', (evt) => {
      evt.preventDefault(); // Better than doing that void(0) thing.
      olark('api.box.expand');
    })

    // Prioritize rid passed by query string
    // Otherwise, use a page-specific token.
    olarkSetRid(getParameterByName('rid') || integrationName);

  });
});
